import { inject } from 'vue'
import { lovContextKey } from '../LovInput'

export default function useLov() {
  return inject(lovContextKey)
}
